/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable object-curly-newline */
/* eslint-disable max-len */
import React from "react";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import Grid from "@mui/material/Grid";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Drawer from "@mui/material/Drawer";
import Tooltip from "@mui/material/Tooltip";
import Badge from "@mui/material/Badge";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import Avatar from "@mui/material/Avatar";
import InputAdornment from "@mui/material/InputAdornment";

import SearchIcon from "@mui/icons-material/Search";
import NotificationsIcon from "@mui/icons-material/Notifications";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import ArrowRightIcon from "@mui/icons-material/ArrowForward";
import ArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import CloseIcon from "@mui/icons-material/Close";

import type { HeaderProps } from "./Header";

import SompoTextField from "../textField/SompoTextField";
import Category from "../category/Category";
import { ZINDEX_HEADER } from "../Theme";

import { AccessLevel } from "../../Constants";
import SompoContext from "../../logic/context/SompoContext";
import { showSearchMenu, showSkillMenu, showAdministratorMenu, showInformationMenu, showUserMenu } from "../../logic/companies/Companies";
import SompoLoading from "../loading/SompoLoading";

const Desktop = (props: HeaderProps) => {
    const sompoContext = React.useContext(SompoContext);

    // 管理者メニューの表示是非
    const accessLevel = sompoContext.userDetail.accessLevelId1;
    const showAdminMenu = showAdministratorMenu() && accessLevel !== AccessLevel.NORMAL;

    // 研修・講座の検索欄に使用
    const searchText = React.useRef<HTMLInputElement>(null!);

    // カテゴリーを表示するドロワー
    const [searchDrawerOpen, setSearchDrawerOpen] = React.useState(false);

    // カテゴリーを表示するドロワーを閉じる
    const closeSearchDrawer = () => {
        setSearchDrawerOpen(false);
    };

    // ユーザメニューに使用
    const [userMenuAnchor, setUserMenuAnchor] = React.useState<null | HTMLElement>(null);

    // ユーザーメニューを開く
    const openUserMenu = (event: React.MouseEvent<HTMLElement>) => {
        setUserMenuAnchor(event.currentTarget);
        closeSearchDrawer();
    };

    // ユーザーメニューを閉じる
    const closeUserMenu = () => {
        setUserMenuAnchor(null);
    };

    // カテゴリーを表示するドロワーを開き、ユーザーメニューを閉じる
    const openSearchDrawer = () => {
        closeUserMenu();
        setSearchDrawerOpen(true);
    };

    const handleInputChange = (event: { target: { value: string } }) => {
        props.setTrainingSearchText(event.target.value);
    };

    const search = () => {
        closeSearchDrawer();
        props.handleTrainingList();
    };

    return (
        <>
            <Grid
                container
                direction="row"
                flexWrap="nowrap"
                sx={{
                    m: 0,
                    width: "100%",
                    height: "100%",
                }}
            >
                <Grid
                    item
                    display="flex"
                    alignItems="center"
                    justifyContent="center"
                    sx={{
                        px: 2,
                        "&: hover": {
                            cursor: "pointer",
                        },
                    }}
                    onClick={props.handleHome}
                >
                    {(() => {
                        const image = sompoContext.companySettings?.ui?.title;
                        if (!image) {
                            return <></>;
                        }
                        return <Box component="img" src={image} sx={{ height: "48px", maxHeight: "48px" }} />;
                    })()}
                </Grid>

                <Grid item flexGrow={1}>
                    {showSearchMenu() && (
                        <form
                            onSubmit={search}
                            style={{
                                display: "flex",
                                height: "100%",
                                alignItems: "center",
                                justifyContent: "center",
                            }}
                        >
                            <SompoTextField
                                size="small"
                                variant="outlined"
                                label={
                                    <Box
                                        sx={{
                                            display: "flex",
                                            justifyContent: "flex-start",
                                            alignItems: "center",
                                        }}
                                    >
                                        <SearchIcon sx={{ fontSize: "1.2rem" }} />
                                        <Typography
                                            variant="body1"
                                            sx={{
                                                overflow: "hidden",
                                                textOverflow: "ellipsis",
                                                whiteSpace: "nowrap",
                                                color: "#7C8188",
                                            }}
                                        >
                                            研修・講座を検索
                                        </Typography>
                                    </Box>
                                }
                                InputProps={{
                                    endAdornment: searchDrawerOpen && (
                                        <InputAdornment position="end">
                                            <IconButton
                                                onClick={(event: React.MouseEvent<unknown>) => {
                                                    closeSearchDrawer();
                                                    event.stopPropagation();
                                                }}
                                            >
                                                <CloseIcon />
                                            </IconButton>
                                        </InputAdornment>
                                    ),
                                }}
                                sx={{
                                    width: "90%",
                                    borderRadius: "24px",
                                    backgroundColor: "#F5F6F6",
                                    "& .MuiOutlinedInput-notchedOutline": {
                                        borderRadius: "24px",
                                    },
                                }}
                                onClick={openSearchDrawer}
                                onChange={handleInputChange}
                                ref={searchText}
                            />
                        </form>
                    )}
                </Grid>

                <Grid item>
                    <Grid container direction="row" flexWrap="nowrap" alignItems="center" columnSpacing={1.5} sx={{ width: "100%", height: "100%" }}>
                        {showSkillMenu() && (
                            <Grid item>
                                <Button
                                    sx={{
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        backgroundColor: "#444C55",
                                        height: { sm: 25, md: 30 },
                                        borderRadius: "16px",
                                        transition: "all 0.2s ease-in-out",
                                        color: "#fff",
                                        p: "0 15px",
                                        "&: hover": {
                                            backgroundColor: "#444C55",
                                            opacity: 0.7,
                                        },
                                    }}
                                    onClick={props.handleSkillMap}
                                >
                                    <SearchIcon sx={{ fontSize: "1.2rem" }} />
                                    <Typography
                                        variant="body2"
                                        sx={{
                                            whiteSpace: "nowrap",
                                        }}
                                    >
                                        スキルから講座を探す
                                    </Typography>
                                    <ArrowRightIcon sx={{ fontSize: "0.9rem", ml: 1 }} />
                                </Button>
                            </Grid>
                        )}

                        {showAdminMenu && (
                            <Grid
                                item
                                onClick={() => {
                                    props.handleOpenManagerWindow!();
                                }}
                                sx={{
                                    width: "100%",
                                    height: "100%",
                                    display: "flex",
                                    alignItems: "center",
                                    ml: 3,
                                    "&: hover": {
                                        cursor: "pointer",
                                    },
                                }}
                            >
                                <Typography variant="body2" sx={{ whiteSpace: "nowrap" }}>
                                    管理者メニュー
                                </Typography>
                            </Grid>
                        )}

                        {showInformationMenu() && (
                            <Grid item sx={{ ml: 1 }}>
                                <Tooltip title="お知らせ">
                                    <Box
                                        sx={{
                                            height: "100%",
                                            display: "flex",
                                            alignItems: "center",
                                            transition: ".3s",
                                            "&: hover": {
                                                cursor: "pointer",
                                            },
                                        }}
                                        onClick={props.handleInfo}
                                    >
                                        {props.hasNewInformation ? (
                                            <Badge
                                                sx={{
                                                    "& .MuiBadge-badge": {
                                                        backgroundColor: "#C00000",
                                                    },
                                                }}
                                                badgeContent={""}
                                                color="info"
                                                variant="dot"
                                                overlap="circular"
                                            >
                                                <NotificationsIcon />
                                            </Badge>
                                        ) : (
                                            <NotificationsIcon />
                                        )}
                                    </Box>
                                </Tooltip>
                            </Grid>
                        )}

                        {showUserMenu() && (
                            <Grid
                                item
                                sx={{
                                    height: "100%",
                                    display: "flex",
                                    alignItems: "center",
                                    ml: 1,
                                    "&: hover": {
                                        cursor: "pointer",
                                    },
                                }}
                                onClick={openUserMenu}
                            >
                                {(() => {
                                    const image = sompoContext.userImage;
                                    if (!image) {
                                        return <AccountCircleIcon />;
                                    }
                                    return (
                                        <Avatar
                                            src={image}
                                            sx={{
                                                width: "58px",
                                                minWidth: "58px",
                                                height: "58px",
                                                minHeight: "58px",
                                            }}
                                        />
                                    );
                                })()}
                                <ArrowDownIcon />
                            </Grid>
                        )}

                        <Grid item>
                            <Menu
                                sx={{
                                    mt: "50px",
                                    zIndex: ZINDEX_HEADER,
                                    "& .MuiList-root": {
                                        color: "#FAFAFA",
                                        bgcolor: "#7C8188",
                                        p: 0,
                                        width: "250px",
                                    },
                                }}
                                anchorEl={userMenuAnchor}
                                anchorOrigin={{
                                    vertical: "top",
                                    horizontal: "right",
                                }}
                                keepMounted
                                open={Boolean(userMenuAnchor)}
                                onClose={closeUserMenu}
                            >
                                <Box
                                    sx={{
                                        borderBottom: "2px solid #9BA1AB",
                                        p: 2.3,
                                        display: "flex",
                                        flexFlow: "column",
                                        alignItems: "flex-start",
                                    }}
                                >
                                    <Typography variant="body2" sx={{ wordBreak: "break-all" }}>
                                        {sompoContext.userDetail.familyNameJa} {sompoContext.userDetail.firstNameJa}
                                    </Typography>
                                    <Typography variant="body2">{sompoContext.userDetail.email1}</Typography>
                                </Box>
                                <MenuItem onClick={props.handleProfile} sx={{ borderBottom: "2px solid #9BA1AB", p: 2.3 }}>
                                    <Typography variant="body2">マイページ・受講履歴</Typography>
                                </MenuItem>
                                {sompoContext.loading || sompoContext.skillMapLoading || sompoContext.skillMapDrawerLoading ? (
                                    <Box
                                        sx={{
                                            borderBottom: "2px solid #9BA1AB",
                                            p: 2.3,
                                            display: "flex",
                                            flexFlow: "column",
                                            alignItems: "flex-start",
                                            position: "relative",
                                        }}
                                    >
                                        <SompoLoading progressColor="#FAFAFA" />
                                    </Box>
                                ) : (
                                    <MenuItem onClick={props.handleLogout} sx={{ p: 2.3 }}>
                                        <Typography variant="body2">ログアウト</Typography>
                                    </MenuItem>
                                )}
                            </Menu>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>

            <Box>
                <Drawer
                    anchor="top"
                    open={searchDrawerOpen}
                    onClose={closeSearchDrawer}
                    disableAutoFocus // ドロワ側への自動フォーカスを無効化
                    disableEnforceFocus // ドロワからフォーカスが外せるように
                    ModalProps={{ disableScrollLock: true }}
                >
                    <Toolbar />
                    <Box
                        sx={{
                            width: "100%",
                            height: "auto",
                            minHeight: "100px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            p: "80px 0",
                        }}
                    >
                        <Box
                            sx={{
                                width: "70%",
                                height: "100%",
                                display: "flex",
                                alignItems: "flex-start",
                                justifyContent: "center",
                                flexFlow: "column",
                            }}
                        >
                            <Category border={true} setDrawerOpen={setSearchDrawerOpen} />
                        </Box>
                    </Box>
                </Drawer>
            </Box>
        </>
    );
};

export default Desktop;
